import { GregorioBar } from '../enums/GregorioBar';
import { GregorioClefInfo } from './GregorioClef';
import { GregorioGlyph } from './GregorioGlyph';
import { GregorioNlba } from '../enums/GregorioNlba';
import { GregorioSign } from '../enums/GregorioSign';
import { GregorioSpace } from '../enums/GregorioSpace';
import { GregorioType } from '../enums/GregorioType';
import { GregorioSegment } from './GregorioSegment';
import { TextSpan } from './TextSpan';


export class GregorioSyllable {
    textSpans: TextSpan[] = [];
    segments: GregorioSegment[] = [];
    position!: GregorioWordPosition;
    keepWithNext = false;

    get hasBar(): boolean {
        return this.segments.some((s) => s.hasBar);
    }

    get isBar(): boolean {
        return this.segments.every((s) => s.isBar);
    }

    get isClef(): boolean {
        return this.segments.every((s) => s.isClef);
    }

    get elements() {
        return this.segments.flatMap((s) => s.elements);
    }

    get clefChange(): GregorioElement | undefined {
        const elements = this.elements;
        const element = elements[0];
        const next_element = elements[1];
        const next_next_element = elements[2];
        const next_next_next_element = elements[3];
        /* we just detect the foud cases */
        if (element.type == GregorioType.CUSTOS && next_element
            && (next_element.type === GregorioType.CLEF) && !next_next_element) {
            return next_element;
        }
        if (element.type == GregorioType.BAR && next_element
            && (next_element.type === GregorioType.CLEF) && !next_next_element) {
            return next_element;
        }
        if ((element.type === GregorioType.CLEF) && !next_element) {
            return element;
        }
        if (element.type == GregorioType.CUSTOS && next_element
            && next_element.type == GregorioType.BAR && next_next_element
            && (next_next_element.type === GregorioType.CLEF)
            && !next_next_next_element) {
            return next_next_element;
        }
        return undefined;
    }
}


export class GregorioElement {
    get first_glyph(): GregorioGlyph {
        return this.glyphs[0];
    }

    get last_glyph(): GregorioGlyph {
        return this.glyphs[this.glyphs.length - 1];
    }

    get hasEpisema(): boolean {
        return this.glyphs.some(g => g.hasEpisema);
    }

    glyphs: GregorioGlyph[] = [];
    misc: GregorioMiscElementInfo = new GregorioMiscElementInfo();
    type?: GregorioType;
}

export class GregorioMiscElementInfo {
    pitch!: number;
    force_pitch!: boolean;
    clef: GregorioClefInfo = new GregorioClefInfo();
    info: GregorioExtraInfo = new GregorioExtraInfo();
    special_sign!: GregorioSign;
}

export class GregorioExtraInfo {
    ad_hoc_space_factor?: string;
    bar!: GregorioBar;
    space!: GregorioSpace;
    nlba!: GregorioNlba;
    eol?: GregorioEndOfLineInfo;
}

export class GregorioEndOfLineInfo {
    eol_ragged!: boolean;
    eol_forces_custos!: boolean;
    eol_forces_custos_on!: boolean;
}

export enum GregorioTrCentering {
    NORMAL,
    WITH_CENTER_BEGINNING,
    WITH_CENTER_END
}

export enum GregorioWordPosition {
    BEGINNING,
    WORD_MIDDLE,
    WORD_END,
    WORD_ONE_SYLLABLE,
}

export enum GregorioEuouae {
    NORMAL,
    BEGINNING,
    END,
}
